import React from 'react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-140" data-mp="17xuswfmwwmsb">
      <div className="mx-auto max-w-md" data-id="element-141" data-mp="1mo2182j7gpfa">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-142" data-mp="1mmqz075erpqa">
          Offerta Speciale di Lancio
        </h2>

        <div className="relative mt-10 rounded-3xl border-2 border-brand bg-white px-7 pb-8 pt-11 shadow-soft" data-id="element-143" data-mp="tzmojmnjqj74">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-brand px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-144" data-mp="p1bg9gcwggr0">
            INGLESE PRONTO™ Pack
          </span>

          <dl data-id="element-145" data-mp="2fc68utlc7ckm">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-ink/10 py-4 text-sm" data-id="element-146" data-mp="2famuj8j8rblh">
                <dt className="text-ink/80" data-id="element-147" data-mp="pl0cxuyqtwee">{row.label}</dt>
                <dd className="font-bold text-brand" data-id="element-148" data-mp="pmlc5xw063il">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between border-b border-ink/10 py-4 text-sm" data-id="element-149" data-mp="zieuxz0bet8t">
              <dt className="font-bold uppercase tracking-wide text-ink" data-id="element-150" data-mp="13k01l2m9abak">
                Valore Totale:
              </dt>
              <dd className="font-bold text-amber-700 line-through" data-id="element-151" data-mp="6u95x028ai36">€225</dd>
            </div>
          </dl>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-brand" data-id="element-152" data-mp="bs0wnqr4zy5s">
            Solo per oggi
          </p>
          <p className="flex items-baseline justify-center gap-2 border-b border-ink/10 pb-7 pt-2" data-id="element-153" data-mp="fsb7phtsderi">
            <span className="font-display text-6xl font-black leading-none text-brand" data-id="element-154" data-mp="kmyvtfkvo75k">
              €19
            </span>
          </p>

          <p className="mt-5 text-center text-[11px] font-medium leading-relaxed text-ink/60" data-id="element-155" data-mp="3o9fovnm9nhvg">
            Pagamento unico, accesso a vita. Nessun abbonamento.
          </p>

          <CtaButton className="mt-4 w-full" data-id="element-156" data-mp="qgnpoazkcuh2" />

          <p className="mt-4 text-center text-[11px] font-medium text-ink/50" data-id="element-157" data-mp="qfutg3y8dnd6">
            Download Istantaneo · Pagamento Unico · Accesso a Vita · Garanzia di
            7 Giorni
          </p>
        </div>
      </div>
    </section>;
}